import React, { useEffect, useState } from 'react'
import { compose } from 'recompose'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import StyledWrapper from '../../../components/StyledWrapper'
import * as cookies from '../../../utilties/cookies'
import { withRouter } from 'react-router'

import defaultPathologyImage from '../../../assets/dashboard/results.jpg'
import defaultTreatmentImage from '../../../assets/dashboard/treatment.jpg'
import { getCase } from '../../../redux/actions'
import { caseSelector, currentCaseSelector, pathologySelector, treatmentSelector } from '../../../redux/selectors'

import { connect } from 'react-redux'
import { injectIntl, FormattedDate } from 'react-intl'

import Container from '@material-ui/core/Container';


const useStyles = makeStyles((theme) => ({
    caseMainContent: {
        paddingTop: '61px'
    },
    containerOuter: {
        [theme.breakpoints.down('md')]: {
            margin: '0',
            overflowX: 'hidden',
            maxWidth: '100%',
            width: '100%',
            padding: '0'

        },
    },
	titleRoot: {
		color: 'white',
		fontWeight: '400',
		padding: '32px 0 24px',
		textAlign: 'left',
		textShadow: '0 1px 1px #000',
	},
    textRoot: {
        margin: '0 0 24px 0',
        fontSize: '33px',
        fontWeight: '300'
    },
    descriptionRoot: {
        margin: '0 0 30px 0',
        lineHeight: '1.8'
    },
    imageRoot: {
        width: '100%',
        height: 'auto',
        boxShadow: '0 5px 10px rgba(0,0,0,0.09), 0 3px 3px rgba(0,0,0,0.13)'
    },
    treatmentDesc: {
        [theme.breakpoints.down('sm')]: {
            order: 4,
        }
    },
    treatmentImg: {
        [theme.breakpoints.down('sm')]: {
            order: 3,
        }
    }
}))

const Error = ({
    intl,
    thisCase,
    currentCase,
    loadCase,
    pathology,
    treatment
}) => {

    const classes = useStyles()
    const [patient] = useState(cookies.get('user'))

    useEffect(
        () => {
            loadCase(patient.id)
        },
        [currentCase && currentCase.Id]
    )

    return (
        <StyledWrapper>
             <Container maxWidth="lg" style={{ paddingBottom: '61px' }}>
                {/* <Grid container>
                        <Grid item xs={12}>
                            <Typography data-testid="case-title" variant='h4' className={classes.titleRoot}>
                                {intl.formatMessage({ id: `app.menu.case` })}
                            </Typography>
                        </Grid>
                </Grid> */}

                <Grid container className={classes.caseMainContent}> 
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2rem', minHeight: '300px' }} elevation={2}>
                            <Typography variant="h2"
                                style={{
                                    fontSize: '22px',
                                    letterSpacing: '0.23px',
                                    fontWeight: '700',
                                    marginBottom: '5px'
                                }}>
                                {intl.formatMessage({ id: `app.menu.case` })}
                            </Typography>
                            {/*
                                thisCase && thisCase.treatmentDate &&
                                <Typography
                                    style={{
                                        fontSize: '16px',
                                        letterSpacing: '0.23px',
                                        textAlign: 'left',
                                        fontWeight: '700',
                                        marginBottom: '10px'
                                    }}>
                                    {intl.formatMessage({ id: `app.case.commencementDate` })} : <FormattedDate year='numeric' month='long' day='2-digit' value={thisCase.treatmentDate} year="numeric" month="long" day="2-digit" />
                                </Typography>
                                */}

                            <hr style={{ margin: '19px 0 30px 0', minWidth: '70px', width: '5vw', height: '2px', backgroundColor: 'black', borderWidth: 0 }} />

                            <Grid container spacing={6} className="patient-case-details-wrapper">

                                <Grid item sm={12} md={6} className="patient-pathology-img-wrapper">
                                    <img alt="Indication Image" data-testid="patient-pathology-img" src={pathology.imageUrl ? pathology.imageUrl : defaultPathologyImage} className={classes.imageRoot} />
                                </Grid>
                                <Grid item sm={12} md={6} className="patient-pathology-desc-wrapper">
                                    {pathology.name &&
                                        <Typography data-testid="patient-pathology-name" variant='h4' className={classes.textRoot}>
                                            {pathology.name}
                                        </Typography>
                                    }
                                    {pathology.description &&
                                        <Typography data-testid="patient-pathology-decription" variant='body1' className={classes.descriptionRoot}>
                                            {pathology.description}
                                        </Typography>
                                    }
                                </Grid>

                                <Grid item sm={12} md={6} className={classes.treatmentDesc + ` patient-treatment-desc-wrapper`}>
                                    {treatment.name &&
                                        <Typography data-testid="patient-treatment-name" variant="h4" className={classes.textRoot}>
                                            {treatment.name}
                                        </Typography>
                                    }
                                    {treatment.description &&
                                        <Typography data-testid="patient-treatment-description" variant="body1" className={classes.descriptionRoot}>
                                            {treatment.description}
                                        </Typography>
                                    }
                                </Grid>
                                <Grid item sm={12} md={6} className={classes.treatmentImg + ` patient-treatment-img-wrapper`}>
                                    <img alt="Treatment Image" data-testid="patient-treatment-img" src={treatment.imageUrl ? treatment.imageUrl : defaultTreatmentImage} className={classes.imageRoot} />
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>

            </Container>
        </StyledWrapper>
    )
}

const mapStateToProps = (state, ownProps) => ({
    pathology: pathologySelector(state),
    treatment: treatmentSelector(state),
    currentCase: currentCaseSelector(state),
    thisCase: caseSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    loadCase: (patientId) => dispatch(getCase(patientId))
})

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	injectIntl,
	withRouter
)

export default enhance(Error)
